export const GetMinutesString = (minutes: number) => {
  return minutes === 1 ? 'minute' : 'minutes'
}
